// Keep normal wheel/trackpad scrolling inside the page. Only the stationary
// header and dock surround need forwarding because they sit outside its row.
export function connectWorkspaceEdgeScroll(workspace) {
  if (!workspace) return () => {};
  const onWheel = event => {
    if (event.defaultPrevented || event.ctrlKey || event.metaKey || !event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    const main = workspace.querySelector('#journal-main,#experience-main');
    const target = event.target;
    if (!main || !(target instanceof Element) || main.contains(target) ||
      target.closest('[role="dialog"],[aria-modal="true"],.tl-workspace-arrival,.tl-orbit-entry,[data-tl-navigation-dialog]') || document.querySelector('[aria-modal="true"]')) return;
    // Respect any independent scroll control in the header or navigation.
    for (let node = target; node && node !== workspace; node = node.parentElement) {
      if (node.scrollHeight > node.clientHeight && /auto|scroll/.test(getComputedStyle(node).overflowY)) return;
    }
    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? main.clientHeight : 1;
    const delta = event.deltaY * unit;
    const top = Math.max(0, Math.min(main.scrollHeight - main.clientHeight, main.scrollTop + delta));
    if (top === main.scrollTop) return;
    event.preventDefault();
    main.scrollTop = top;
  };
  workspace.addEventListener('wheel', onWheel, { passive: false });
  return () => workspace.removeEventListener('wheel', onWheel);
}
